module.exports = __webpack_public_path__ + "img/08.e22d2263.png";